export default [
  'For all previous years, only the final round Opening/Closing ranks are shown here.',
  'Every filter is applied as soon as you select its value and results can be seen upon scrolling to below table.',
  'Column headers can be clicked to sort any particular column in ascending/descending order.',
  'Opening/Closing Rank that have ( - P ) with it denotes Preparatory Rank.',
  'Personal Rank based search: Enter your JEE Adv. Rank or JEE Main Rank (n) and a delta (d), and you will get all the programs for which closing rank > (n + d)',
  'Example 1: JEE Adv. Rank = 1000 and delta = 100; will give you all the programs in IITs whose closing rank is >1100',
  'Example 2: JEE Main Rank = 1000 and delta = -50; will give you all the programs in NITs whose closing rank is >950'
]
